import { v4 } from "uuid";
import { IDataTableColumn } from "winfakt-vue-components";

export class MongoViewColumn {
	key:string = v4();
	Name:string = "New column";
	Property:string = "_id";
	Width:string | null = null;

	public constructor(data?:{Name:string, Property:string, Width?:string | null}){
		if (!data) return;
		this.Name = data.Name.trim();
		this.Property = data.Property;
		this.Width = data.Width || null;
	}

	public getJSON(){
		return {
			Name: this.Name,
			Property: this.Property,
			Width: this.Width
		};
	}

	public toDataTableColumn(availableColumns:IAvailableMongoViewColumn[]):IDataTableColumn{
		let col = availableColumns.find(a=>a.viewColumnName == this.Property);
		if (!col){
			return{
				name: "ERROR",
				property: "ERROR",
				print(){
					return "ERROR";
				}
			};
		}
		let newCol = {...col};
		newCol.name = this.Name;
		newCol.width = this.Width || col.width;
		return newCol;
	}

	public static fromAvailableColumn(col:IAvailableMongoViewColumn):MongoViewColumn{
		let newCol = new MongoViewColumn();
		newCol.Name = col.name;
		newCol.Property = col.viewColumnName;
		newCol.Width = col.width || null;
		return newCol;
	}
}

export interface IAvailableMongoViewColumn extends IDataTableColumn{
	viewColumnName:string;
}